import { type FC, useState } from 'react';
import { isLocal, isPreproduction } from '@Shared/env/env';
import '@Styles/auth-required.css';

export const SessionStorageHelp: FC = () => {
  const [copySuccess, setCopySuccess] = useState(false);

  const sessionStorageKey = import.meta.env.VITE_AUTH_SESSION_KEY;
  const shouldShowBanner = isLocal || isPreproduction;

  if (!shouldShowBanner) {
    console.error(
      'Error de autenticación: No se encontraron datos de sesión en el Session Storage.'
    );
    return null;
  }

  const handleCopyKey = async () => {
    if (!sessionStorageKey) return;
    try {
      await navigator.clipboard.writeText(sessionStorageKey);
      setCopySuccess(true);
    } catch (error) {
      console.error('Error al copiar el key:', error);
    }
  };

  return (
    <div className="session-help__wrapper">
      <div className="session-help__content">
        <div className="session-help__body">
          <p className="session-help__title">Error de Autenticación - Configuración Requerida</p>

          <div className="session-help__body-inner">
            <p className="session-help__body-text">Para usar esta aplicación, sigue estos pasos:</p>

            <ol className="session-help__list">
              <li>
                Abre{' '}
                <a
                  href="https://dpxpre.iberia.es"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="session-help__link"
                >
                  https://dpxpre.iberia.es
                </a>{' '}
                e inicia sesión
              </li>
              <li>Abre DevTools (F12) → Application → Session Storage</li>
              <li>
                Busca y copia el <strong>valor completo</strong> del key:
                <div className="session-help__key-box">
                  <code className="session-help__key-code">{sessionStorageKey}</code>
                  <button
                    onClick={handleCopyKey}
                    className="session-help__copy-btn"
                    aria-label="Copiar key de session storage"
                  >
                    {copySuccess ? '✓ Copiado' : 'Copiar Key'}
                  </button>
                </div>
              </li>
              <li>En esta ventana, abre DevTools (F12) → Application → Session Storage</li>
              <li>
                Crea un nuevo ítem:
                <ul className="session-help__sublist">
                  <li>
                    <strong>Key:</strong>{' '}
                    <code className="session-help__key-code">{sessionStorageKey}</code>
                  </li>
                  <li>
                    <strong>Value:</strong> [pega el objeto JSON completo que copiaste]
                  </li>
                </ul>
              </li>
              <li>Refresca esta página (F5)</li>
            </ol>
          </div>
        </div>
      </div>

      <footer className="session-help__footer">
        <p>
          <strong>Nota:</strong> La sesión expira después de unas horas. Si vuelve a aparecer este
          mensaje, repite estos pasos.
        </p>
      </footer>
    </div>
  );
};
